import { useState } from "react";
import { Expand } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/shared/Reveal";
import { Lightbox } from "@/components/shared/Lightbox";

const B = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts";

const PHOTOS = [
  { image: `${B}/dgvc4i38_IMG_3519.jpg` },
  { image: `${B}/pwf4y2x8_DSC07033.webp` },
  { image: `${B}/opvv8j1w_IMG_1236.jpg` },
  { image: `${B}/6rdyobkm_DSC07295.webp` },
  { image: `${B}/0rfl2701_DSC07020.webp` },
  { image: `${B}/qd51osmt_DSC07254.webp` },
];

const Tile = ({ i, onOpen }) => (
  <button
    type="button"
    data-testid={`gallery-tile-${i}`}
    onClick={() => onOpen(i)}
    className="group relative overflow-hidden rounded-2xl border border-white/10 aspect-[4/5]"
  >
    <img
      src={PHOTOS[i].image}
      alt="Novemberkåsan"
      loading="lazy"
      className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-black/10 group-hover:bg-black/0 transition-colors" />
    <span className="absolute top-3 right-3 grid place-items-center h-9 w-9 rounded-full bg-black/50 backdrop-blur text-white/85 opacity-0 group-hover:opacity-100 transition-opacity">
      <Expand className="w-4 h-4" />
    </span>
  </button>
);

export const Gallery = () => {
  const [idx, setIdx] = useState(null);

  return (
    <section data-testid="gallery" className="relative py-24 sm:py-32 bg-[#0A0B0D]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <SectionHeader
            kicker="Ögonblick"
            title="Där legender föds"
            subtitle="Rått, mörkt och obarmhärtigt vackert – Novemberkåsan mitt i leran, elden och novembernatten."
          />
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
            {PHOTOS.map((_, k) => (
              <Tile key={k} i={k} onOpen={setIdx} />
            ))}
          </div>
        </Reveal>
      </div>
      {idx !== null && <Lightbox items={PHOTOS} index={idx} onClose={() => setIdx(null)} onNav={setIdx} />}
    </section>
  );
};
